import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

// Looping bounce: up, pause, up, pause
const bounceLoop = keyframes`
  0% { transform: translateY(0); }
  10% { transform: translateY(-20px); }
  20% { transform: translateY(0); }
  100% { transform: translateY(0); }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
`;

const Character = styled.div`
  font-size: 60px;
  animation: ${bounceLoop} 1.5s infinite;
`;

const Message = styled.div`
  font-family: 'Montserrat', sans-serif;
  color: var(--al-primary);
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 16px;
  border-radius: 20px;
  margin-top: 10px;
  font-size: 18px;
`;

const JapaneseText = styled.div`
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 14px;
  opacity: 0.8;
  margin-top: 4px;
`;

// "Go home happy!" in Japanese: "幸せに帰ってね！"
// (shiawase ni kaette ne!)

const PrintlistSuccessAnimation = () => (
  <Container>
    <Character>ʕ•ᴥ•ʔ</Character>
    <JapaneseText>幸せに帰ってね！</JapaneseText>
  </Container>
);

export default PrintlistSuccessAnimation; 